import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Blog.css';

const Blog = () => {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noticiaSeleccionada, setNoticiaSeleccionada] = useState(null);

  const obtenerNoticias = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/noticias');
      setNoticias(response.data);
    } catch (error) {
      setError('Hubo un error al cargar las noticias.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerNoticias();
  }, []);

  const cortarTexto = (texto, maxCaracteres) => {
    if (!texto) return ''; 
    return texto.length > maxCaracteres 
      ? texto.substring(0, maxCaracteres) + '...' 
      : texto;
  };

  const abrirModal = (noticia) => {
    setNoticiaSeleccionada(noticia);
  };

  const cerrarModal = () => {
    setNoticiaSeleccionada(null);
  };

  return (
    <div className="blog">
      <div className="blog-background">
        <img src="/images/blogbackground.jpg" alt="Fondo del blog" />
      </div>
      <div className="blog-overlay"></div>

      <div className="blog-container">
        <h3>Blog</h3>

        {loading && <p>Cargando noticias...</p>}
        {error && <p>{error}</p>}

        <ul className="lista-noticias">
          {noticias.length > 0 ? (
            noticias.map((noticia) => (
              <li key={noticia._id} className="noticia-item">
                <img 
                  src={`http://localhost:5000${noticia.imagen}`} 
                  alt={noticia.titulo} 
                  className="imagen-noticia" 
                />
                <h4>{noticia.titulo}</h4>
                <p className="contenido-noticia">
                  {cortarTexto(noticia.contenido.join(' '), 180)}
                </p>
                <p className="fecha-noticia">
                  Fecha: {new Date(noticia.fecha).toLocaleDateString()}
                </p>
                <button className="boton-mostrar-mas" onClick={() => abrirModal(noticia)}>Mostrar más</button>
              </li>
            ))
          ) : (
            !loading && <p>No hay noticias disponibles.</p>
          )}
        </ul>
      </div>

      {noticiaSeleccionada && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
            <button className="modal-cerrar" onClick={cerrarModal}>X</button>
            <h2>{noticiaSeleccionada.titulo}</h2>
            <p className="modal-cuerpo">{noticiaSeleccionada.contenido.join(' ')}</p>
            <p className="modal-fecha">Fecha: {new Date(noticiaSeleccionada.fecha).toLocaleDateString()}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blog;
